import { useTranslation } from 'react-i18next';

import { Header } from '../components/index.jsx';
import { Members } from '../components/Members/index.jsx';
import { getSidebarLinksMap } from '../utils/ui';

const MembersPage = () => {
  const { t } = useTranslation();
  const SidebarLinksMap = getSidebarLinksMap(t);

  return (
    <>
      <Header title={SidebarLinksMap.team.title} t={t} />
      <main className="main">
        <Members t={t} />
      </main>
    </>
  )
}

export default MembersPage;